import React from 'react'
import './Services.css'

const Services = () => {
  return (
    <div className='serv'>
        <div className="servb">
            <div className="title">
                <span className='titles'>Little Stars</span>
            <p>(6 months - 2 years)</p>
            </div>
          
            <hr />
            <div className="info">

                <span className="describe">- Special dietary (if any)</span>
                <span>- 4 nappies per day & nappy plastic</span>
                <span>- 3 packs of wipes</span>
                <span>- Vaseline 250ml or Aqueous cream (x2)</span>
                <span>- 2 boxes of facial tissues</span>
                <span>- Blanket</span>
                <span>- Communication book (small notebook)</span>
                <div className="box">R400pm</div>
            </div>
        </div>
        <div className="servb">
            <div className="title-1">
                <span className='titles'>Curious Cubs</span>
            <p>(2 - 3 years)</p>
            </div>
          
            <hr />
            <div className="info">

                <span className="describe">- 4 nappies per day & nappy plastic</span>
                <span>- 4 packs of wipes & 10 rolls of tissue</span>
                <span>- A4 flip file (20-pocket)</span>
                <span>- Vaseline 250ml Or Aqueous cream(x2)</span>
                <span>- Typek 250 sheets & coloring book</span>
                <span>- Wax crayons (12-pack)</span>
                <span>- Old magazine or Grade 1 workbook</span>
                <span>- Round-edge scissors (x2)</span>
                <span>- 43g Pritt glue (x1)</span>
                <span>- 2 boxes of facial tissues</span>
                <span>- Blanket</span>
                <span>- Communication book (small notebook)</span>
                <div className="box2">R350pm</div>
            </div>
        </div>
        <div className="servb">
            <div className="title-2">
                <span className='titles'>Busy Bees</span>
            <p>(3 years to 4 years 6 months)</p>
            </div>
          
            <hr />
            <div className="info">

                <span className="describe">- vaseline 250ml or Aqueous cream (x2)</span>
                <span>- 72-page exercise book (x2)</span>
                <span>- 4 packs of wipes</span>
                <span>- Blanket</span>
                <span>- 20 rolls of tissue</span>
                <span>- 3kg empty container</span>
                <span>- A4 flip file (30-pocket) (x2)</span>
                <span>- Pencils (x10) & erasers (x4)</span>
                <span>- Typek 500 sheets (x1)</span>
                <span>- Wax crayons (12-pack)</span>
                <span>- 43g Pritt glue (x2)</span>
                <span>- Old magazine or Grade 1 workbook</span>
                <span>- Round-edge scissors (x2)</span>
                <span>- Communication book (small notebook)</span>
                <span>- Alphabet and Numbering Book</span>
                <span>- 3 boxes of facial tissues</span>
                <div className="box3">R300pm</div>
            </div>
        </div>
        <h1 className="cont"> Our Services</h1>
    </div>
  )
}

export default Services